<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/egxo7K/tc-custom/9781453260678.jpg?1703877193477" alt="This image is the cover for the book Kill the Reporter, The Harker Files"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kill the Reporter, The Harker Files
      </h1>
      <p class="bookDescription body article font2">
        <p class="MsoNormal"><b>Harker uncovers a cult whose members believe in peace, love, understanding, and torture</b></p><p class="MsoNormal">Rudolph Franklin thinks his biggest problem is reelection. A battle with a fellow senator about military spending is getting ugly, and if he can’t scrap out a victory, his career will be dead in the water. He calls Harker, a crack investigative reporter, to leak a story for him. Franklin thinks his problems are political—until his daughter disappears. </p><p class="MsoNormal"></p><p class="MsoNormal">In Barbarann’s bedroom, Harker finds pamphlets for the Children’s Crusade, a hippy-dippy cult best known for selling buttons and hard candy on street corners. But Harker learns about the crusade’s darker side—the enforcers charged with keeping members in line, and keeping the press from asking questions. His first warning is a dead cat, hung from the ceiling of his hotel room, paw sliced off. If he crosses the Crusade again, the next paw they take will be his own. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marc Olden
      </h2>
      
      <p class="authorDescription body article">Marc Olden (1933&ndash;2003) was the author of forty mystery and suspense novels. Born in Baltimore, he began writing while working in New York as a Broadway publicist. His first book,&#160;<I>Angela Davis</I>&#160;(1973), was a nonfiction study of the controversial Black Panther. In 1973 he also published&#160;<I>Narc</I>, under the name Robert Hawke, beginning a hard-boiled nine-book series about a federal narcotics agent.<P>A year later,&#160;<I>Black Samurai</I>&#160;introduced Robert Sand, a martial arts expert who becomes the first non-Japanese student of a samurai master. Based on Olden&rsquo;s own interest in martial arts, which led him to the advanced ranks of karate and aikido, the novel spawned a successful eight-book series. Olden continued writing for the next three decades, often drawing on his fascination with Japanese culture and history.&#160;</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a692f770